import { AppStatus } from '../../constants/app-status';
import { AppStatusConfig } from '../../models/application-status-config.interface';
import { CommentCardConfig } from '../../constants/comment-card-config';
import { COMMENT_CARD_TYPES } from '../../enums/comment-card-types.enum';
import { constants } from '../../constants/constants';
import { AppealStatus } from '../../constants/appeal-status';

export class ApplicationStatusUtilityService {
	static getApplicationStatus(appStatusId: number): AppStatusConfig {
		return AppStatus.APP_STATUSES[appStatusId] || AppStatus.APP_STATUSES[0];
	}

	static getAppealStatus(appealStatus: number): AppStatusConfig {
		return (
			AppealStatus.APPEAL_STATUSES[appealStatus] ||
			AppealStatus.APPEAL_STATUSES[0]
		);
	}

	static getMessageCardType(
		commentCardType: COMMENT_CARD_TYPES
	): AppStatusConfig {
		return CommentCardConfig.COMMENT_CARDS[commentCardType];
	}

	static canEditApplicationByStatus(applicationStatusCode: number): boolean {
		return constants.editableStatuses.indexOf(applicationStatusCode) > -1;
	}
}
